import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push,
  replace
} from 'react-router-redux';
import {
  Button,
  Divider,
  Dropdown,
  Loader,
  Segment
} from 'semantic-ui-react';
import {
  Route
} from 'react-router-dom';
import ReactQuill from 'react-quill';
import feathersConnect from './../../../providers/feathersConnect';
import AdminRichTextSection from './AdminRichTextSection';

class AdminPublicTramitesView extends Component {

  constructor (props) {
    super(props);

    this.state = {
      tramite: '',
      options: [
        {
          key: 0,
          text: 'NINGUNO',
          value: ''
        },
        {
          key: 1,
          text: 'Sellados',
          value: 'sellados'
        },
        {
          key: 2,
          text: 'Formacion de Cooperativas',
          value: 'formacion'
        },
        {
          key: 3,
          text: 'Libro',
          value: 'libros'
        },
        {
          key: 4,
          text: 'Asambleas',
          value: 'asambleas'
        },
        {
          key: 5,
          text: 'Asistencia Financiera',
          value: 'asistencia'
        },
        {
          key: 6,
          text: 'Emision de constancias y certificados',
          value: 'emision'
        }
      ]
    };

    this.PublicPagesSservice = this.props.feathers.service('/api/public-pages');
  }

  onSelectionChange (e, input) {
    this.setState({
      tramite: input.value
    });
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let {
      tramite,
      options
    } = this.state;

    return (
      <div>
        <Dropdown
          placeholder="Seleccionar Tramite" selection
          options={options} value={tramite} onChange={this.onSelectionChange.bind(this)} />
        <Divider />
        {
          tramite ?
            <Segment>
              <AdminRichTextSection sectionName={tramite} />
            </Segment> : null
        }
      </div>
    );
  }

}

export default feathersConnect(
  connect(
    AdminPublicTramitesView.mapStateToProps,
    AdminPublicTramitesView.mapDispatchToProps
  )(AdminPublicTramitesView)
);


// WEBPACK FOOTER //
// ./client/components/pages/public-pages/AdminPublicTramitesView.js